
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/chat",
      function () {
        return require("private-next-pages/groups/chat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/chat"])
      });
    }
  